import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'concat'
})
export class ConcatPipe implements PipeTransform {
  transform(first: Array<any>, second: Array<any>): any[] {
    return [...(first || []), ...(second || [])];
  }
}
